<div class="label_properties">
  <small class="debug">{{me}}</small>
  @if (dynamicsInitialized) {
    <div>
      <dynamic-form [fields]="uiConfigInit" (submit)="submit($event)">
      </dynamic-form>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
    </div>
  }
</div>
